<template>
  <h2 :class="['proxima--font font-weight-bold']" :id="slug">{{ label }}</h2>
</template>

<script>
import slugify from 'slugify'
import _includes from 'lodash/includes'

export default {
  name: 'SectionTitleField',
  props: {
    label: {
      type: String,
      default: 'Label',
    },
  },
  components: {},
  data() {
    return {}
  },
  computed: {
    slug() {
      return slugify(this.label, { lower: true, remove: /[*+~.&()'"!:@?\\]/g })
    }, // slug
  },
  methods: {
    _includes,
  },
  mounted() {
    let hash = this.$route.hash.replace('#', '')
    if (hash && hash === this.slug) {
      setTimeout(() => {
        this.$scrollTo(this.$route.hash, 700, { offset: -48 })
      }, 200)
    }
  },
}
</script>
